// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .main-device {
  position: absolute;
  text-align: center;
  background-color: rgb(12, 101, 189);
  color: white;
  border-style: solid;
  border-color: var(--mapBorderColor);
}
:host .node-device {
  position: absolute;
  background-color: rgb(79, 86, 93);
  text-align: center;
  padding-top: 17px;
  border-style: solid;
  border-color: var(--mapBorderColor);
}
:host .node-device mat-icon {
  color: white;
}
:host .node-internal {
  position: absolute;
  background-color: rgb(114, 120, 125);
  text-align: center;
  padding-top: 17px;
  border-style: solid;
  border-color: var(--mapBorderColor);
}
:host .node-internal mat-icon {
  color: white;
}
:host .node-flow {
  position: absolute;
  background-color: rgb(218, 218, 218);
  text-align: center;
  padding-top: 17px;
  border-style: solid;
  border-color: var(--mapBorderColor);
}
:host .node-flow mat-icon {
  color: black;
}
:host .main-line {
  position: absolute;
  background-color: var(--mapBorderColor);
}
:host .main-line-flow {
  position: absolute;
  background-color: var(--mapBorderColor);
}
:host .device-line {
  position: absolute;
  background-color: var(--mapBorderColor);
}
:host .flow-line {
  position: absolute;
  background-color: var(--mapBorderColor);
}
:host .connection-line {
  position: absolute;
  background-color: var(--mapBorderColor);
}
:host .device-header {
  display: block;
  font-size: 17px;
  padding-bottom: 7px;
  padding-top: 0px;
  min-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .device-pro {
  display: block;
  font-size: 12px;
  padding-top: 0px;
  min-height: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .device-pro-line {
  display: inline-block;
  font-size: 12px;
  padding-top: 5px;
}
:host .device-icon {
  position: absolute;
  cursor: pointer;
}
:host .device-edit {
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 17px;
}
:host .device-edit-disabled {
  color: rgb(136, 136, 136) !important;
  cursor: default;
}
:host .device-delete {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 17px;
}
:host .device-list {
  position: absolute;
  right: 30px;
  font-size: 24px;
  bottom: 0px;
}
:host .device-status {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 10px;
  height: 10px;
  border-radius: 4px;
}
:host .container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
  position: absolute;
  bottom: 0px;
  top: 1px;
  left: 0px;
  right: 0px;
}
:host .mat-table {
  overflow: auto;
  /* min-width: 1500px; */
  height: 100%;
}
:host .mat-row {
  min-height: 40px;
  height: 43px;
}
:host .mat-cell {
  font-size: 13px;
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
}
:host .mat-header-cell {
  font-size: 15px;
}
:host .mat-column-select {
  flex: 0 0 100px;
}
:host .mat-column-name {
  flex: 1 1 160px;
}
:host .mat-column-type {
  flex: 0 0 150px;
}
:host .mat-column-polling {
  flex: 0 0 100px;
}
:host .mat-column-address {
  flex: 2 1 300px;
}
:host .mat-column-status {
  flex: 0 0 120px;
}
:host .mat-column-enabled {
  flex: 0 0 160px;
}
:host .mat-column-remove {
  flex: 0 0 60px;
}
:host .selectWidthClass {
  flex: 0 0 100px;
}
:host .selectHideClass {
  flex: 0 0 10px;
}
:host .my-header-filter-input {
  display: block;
  margin-top: 4px;
  margin-bottom: 6px;
  padding: 3px 1px 3px 2px;
  border-radius: 2px;
}
:host .showTable {
  display: flex;
}
:host .hideTable {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/device/device-map/device-map.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/device/device-map/device-map.component.scss"],"names":[],"mappings":"AAUI;EACI,kBAAA;EACA,kBAAA;EACA,mCAbS;EAcT,YAAA;EACA,mBAAA;EACA,mCAfW;ACMnB;ADYI;EACI,kBAAA;EACA,iCAnBO;EAoBP,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mCAtBK;ACYb;ADYQ;EACI,YAAA;ACVZ;ADcI;EACI,kBAAA;EACA,oCA3Ba;EA4Bb,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mCAnCK;ACuBb;ADcQ;EACI,YAAA;ACZZ;ADgBI;EACI,kBAAA;EACA,oCA3CS;EA4CT,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mCA9CW;ACgCnB;ADgBQ;EACI,YAAA;ACdZ;ADkBI;EACI,kBAAA;EACA,uCAzDK;ACyCb;ADmBI;EACI,kBAAA;EACA,uCA3DS;AC0CjB;ADoBI;EACI,kBAAA;EACA,uCAnEK;ACiDb;ADqBI;EACI,kBAAA;EACA,uCArES;ACkDjB;ADsBI;EACI,kBAAA;EACA,uCA7EK;ACyDb;AD8BI;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AC5BR;AD+BI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AC7BR;ADgCI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;AC9BR;ADiCI;EACI,kBAAA;EACA,eAAA;AC/BR;ADkCI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AChCR;ADmCI;EACI,oCAAA;EACA,eAAA;ACjCR;ADoCI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AClCR;ADqCI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;ACnCR;ADsCI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ACpCR;ADwCI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ACtCR;ADyCI;EACI,cAAA;EACA,uBAAA;EACA,YAAA;ACvCR;AD0CI;EACI,gBAAA;EACA,YAAA;ACxCR;AD2CI;EACI,eAAA;ACzCR;AD4CI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;AC1CR;AD6CI;EACI,eAAA;AC3CR;AD8CI;EAEI,eAAA;AC7CR;ADgDI;EACI,eAAA;AC9CR;ADiDI;EACI,eAAA;AC/CR;ADkDI;EACI,eAAA;AChDR;ADmDI;EACI,eAAA;ACjDR;ADoDI;EACI,eAAA;AClDR;ADqDI;EACI,eAAA;ACnDR;ADsDI;EACI,cAAA;ACpDR;ADuDI;EACI,eAAA;ACrDR;ADwDI;EACI,cAAA;ACtDR;ADyDI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;ACvDR;AD0DI;EACI,aAAA;ACxDR;AD2DI;EACI,aAAA;ACzDR","sourcesContent":["$main-backcolor: rgb(12, 101, 189);\n$main-bordercolor: var(--mapBorderColor); //rgb(5, 65, 123);\n$device-color: rgb(79, 86, 93);\n$line-color: var(--mapBorderColor);\n$flow-backcolor: rgb(218, 218, 218);\n$flow-bordercolor: var(--mapBorderColor); //rgb(117, 117, 117);\n$flowline-color: var(--mapBorderColor); //rgb(117, 117, 117);\n$internal-backcolor: rgb(114, 120, 125);\n\n:host {\n    .main-device {\n        position: absolute;\n        text-align: center;\n        background-color: $main-backcolor;\n        color: white;\n        border-style: solid;\n        border-color: $main-bordercolor;\n    }\n\n    .node-device {\n        position: absolute;\n        background-color: $device-color;\n        text-align: center;\n        padding-top: 17px;\n        border-style: solid;\n        border-color: $line-color;\n\n        mat-icon {\n            color: white;\n        }\n    }\n\n    .node-internal {\n        position: absolute;\n        background-color: $internal-backcolor;\n        text-align: center;\n        padding-top: 17px;\n        border-style: solid;\n        border-color: $line-color;\n\n        mat-icon {\n            color: white;\n        }\n    }\n\n    .node-flow {\n        position: absolute;\n        background-color: $flow-backcolor;\n        text-align: center;\n        padding-top: 17px;\n        border-style: solid;\n        border-color: $flow-bordercolor;\n\n        mat-icon {\n            color: black;\n        }\n    }\n\n    .main-line {\n        position: absolute;\n        background-color: $line-color;\n    }\n\n    .main-line-flow {\n        position: absolute;\n        background-color: $flowline-color;\n    }\n\n    .device-line {\n        position: absolute;\n        background-color: $line-color;\n    }\n\n    .flow-line {\n        position: absolute;\n        background-color: $flowline-color;\n    }\n\n    .connection-line {\n        position: absolute;\n        background-color: $line-color;\n    }\n\n    // .main-device mat-icon {\n    //     font-size: 0px;\n    // }\n    // .main-device:hover mat-icon {\n    //     font-size: 17px;\n    // }\n\n    .device-header {\n        display: block;\n        font-size: 17px;\n        padding-bottom: 7px;\n        padding-top: 0px;\n        min-height: 20px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .device-pro {\n        display: block;\n        font-size: 12px;\n        padding-top: 0px;\n        min-height: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .device-pro-line {\n        display: inline-block;\n        font-size: 12px;\n        padding-top: 5px;\n    }\n\n    .device-icon {\n        position: absolute;\n        cursor: pointer;\n    }\n\n    .device-edit {\n        position: absolute;\n        bottom: 0px;\n        right: 0px;\n        font-size: 17px;\n    }\n\n    .device-edit-disabled {\n        color: rgb(136, 136, 136) !important;\n        cursor: default;\n    }\n\n    .device-delete {\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        font-size: 17px;\n    }\n\n    .device-list {\n        position: absolute;\n        right: 30px;\n        font-size: 24px;\n        bottom: 0px;\n    }\n\n    .device-status {\n        position: absolute;\n        bottom: 10px;\n        left: 10px;\n        width: 10px;\n        height: 10px;\n        border-radius: 4px;\n    }\n\n    // Table View Mode\n    .container {\n        display: flex;\n        flex-direction: column;\n        min-width: 300px;\n        position: absolute;\n        bottom: 0px;\n        top: 1px;\n        left: 0px;\n        right: 0px;\n    }\n\n    .mat-table {\n        overflow: auto;\n        /* min-width: 1500px; */\n        height: 100%;\n    }\n\n    .mat-row {\n        min-height: 40px;\n        height: 43px;\n    }\n\n    .mat-cell {\n        font-size: 13px;\n    }\n\n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n    }\n\n    .mat-header-cell {\n        font-size: 15px;\n    }\n\n    .mat-column-select {\n        // overflow: visible;\n        flex: 0 0 100px;\n    }\n\n    .mat-column-name {\n        flex: 1 1 160px;\n    }\n\n    .mat-column-type {\n        flex: 0 0 150px;\n    }\n\n    .mat-column-polling {\n        flex: 0 0 100px;\n    }\n\n    .mat-column-address {\n        flex: 2 1 300px;\n    }\n\n    .mat-column-status {\n        flex: 0 0 120px;\n    }\n\n    .mat-column-enabled {\n        flex: 0 0 160px;\n    }\n\n    .mat-column-remove {\n        flex: 0 0 60px;\n    }\n\n    .selectWidthClass {\n        flex: 0 0 100px;\n    }\n\n    .selectHideClass {\n        flex: 0 0 10px;\n    }\n\n    .my-header-filter-input {\n        display: block;\n        margin-top: 4px;\n        margin-bottom: 6px;\n        padding: 3px 1px 3px 2px;\n        border-radius: 2px;\n    }\n\n    .showTable {\n        display: flex;\n    }\n\n    .hideTable {\n        display: none;\n    }\n}",":host .main-device {\n  position: absolute;\n  text-align: center;\n  background-color: rgb(12, 101, 189);\n  color: white;\n  border-style: solid;\n  border-color: var(--mapBorderColor);\n}\n:host .node-device {\n  position: absolute;\n  background-color: rgb(79, 86, 93);\n  text-align: center;\n  padding-top: 17px;\n  border-style: solid;\n  border-color: var(--mapBorderColor);\n}\n:host .node-device mat-icon {\n  color: white;\n}\n:host .node-internal {\n  position: absolute;\n  background-color: rgb(114, 120, 125);\n  text-align: center;\n  padding-top: 17px;\n  border-style: solid;\n  border-color: var(--mapBorderColor);\n}\n:host .node-internal mat-icon {\n  color: white;\n}\n:host .node-flow {\n  position: absolute;\n  background-color: rgb(218, 218, 218);\n  text-align: center;\n  padding-top: 17px;\n  border-style: solid;\n  border-color: var(--mapBorderColor);\n}\n:host .node-flow mat-icon {\n  color: black;\n}\n:host .main-line {\n  position: absolute;\n  background-color: var(--mapBorderColor);\n}\n:host .main-line-flow {\n  position: absolute;\n  background-color: var(--mapBorderColor);\n}\n:host .device-line {\n  position: absolute;\n  background-color: var(--mapBorderColor);\n}\n:host .flow-line {\n  position: absolute;\n  background-color: var(--mapBorderColor);\n}\n:host .connection-line {\n  position: absolute;\n  background-color: var(--mapBorderColor);\n}\n:host .device-header {\n  display: block;\n  font-size: 17px;\n  padding-bottom: 7px;\n  padding-top: 0px;\n  min-height: 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n:host .device-pro {\n  display: block;\n  font-size: 12px;\n  padding-top: 0px;\n  min-height: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n:host .device-pro-line {\n  display: inline-block;\n  font-size: 12px;\n  padding-top: 5px;\n}\n:host .device-icon {\n  position: absolute;\n  cursor: pointer;\n}\n:host .device-edit {\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  font-size: 17px;\n}\n:host .device-edit-disabled {\n  color: rgb(136, 136, 136) !important;\n  cursor: default;\n}\n:host .device-delete {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  font-size: 17px;\n}\n:host .device-list {\n  position: absolute;\n  right: 30px;\n  font-size: 24px;\n  bottom: 0px;\n}\n:host .device-status {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  width: 10px;\n  height: 10px;\n  border-radius: 4px;\n}\n:host .container {\n  display: flex;\n  flex-direction: column;\n  min-width: 300px;\n  position: absolute;\n  bottom: 0px;\n  top: 1px;\n  left: 0px;\n  right: 0px;\n}\n:host .mat-table {\n  overflow: auto;\n  /* min-width: 1500px; */\n  height: 100%;\n}\n:host .mat-row {\n  min-height: 40px;\n  height: 43px;\n}\n:host .mat-cell {\n  font-size: 13px;\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\n:host .mat-header-cell {\n  font-size: 15px;\n}\n:host .mat-column-select {\n  flex: 0 0 100px;\n}\n:host .mat-column-name {\n  flex: 1 1 160px;\n}\n:host .mat-column-type {\n  flex: 0 0 150px;\n}\n:host .mat-column-polling {\n  flex: 0 0 100px;\n}\n:host .mat-column-address {\n  flex: 2 1 300px;\n}\n:host .mat-column-status {\n  flex: 0 0 120px;\n}\n:host .mat-column-enabled {\n  flex: 0 0 160px;\n}\n:host .mat-column-remove {\n  flex: 0 0 60px;\n}\n:host .selectWidthClass {\n  flex: 0 0 100px;\n}\n:host .selectHideClass {\n  flex: 0 0 10px;\n}\n:host .my-header-filter-input {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 6px;\n  padding: 3px 1px 3px 2px;\n  border-radius: 2px;\n}\n:host .showTable {\n  display: flex;\n}\n:host .hideTable {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
